import React from 'react';
import debounce from 'lodash.debounce';
import SideContentLayout from '@/layouts/Main/sideContentLayout';
import ErrorBoundary from '@web-common/hooks/ErrorBoundary';
import { folderWidthStorePut, DEFAULT_FOLDER_MIN_WIDTH } from '@web-mail/hooks/useAppScale';
const ColumnMailBoxContainer = ({ children, height, defaultWidth, isLeftRight, isMainTab, openInNewWindow, maxWidth, setMailListResizeProcessing }) => {
    if (openInNewWindow) {
        return React.createElement(React.Fragment, null);
    }
    const resize = React.useCallback(debounce((_, data) => {
        const { size: { width }, } = data;
        folderWidthStorePut(width);
    }, 200), [isLeftRight, isMainTab]);
    return (React.createElement(SideContentLayout, { needBtn: true, borderRight: true, className: "m-mailbox-container", style: { position: 'relative' }, defaultheight: height, minWidth: DEFAULT_FOLDER_MIN_WIDTH, maxWidth: maxWidth, onResize: resize, onResizeStop: () => {
            setMailListResizeProcessing && setMailListResizeProcessing(false);
        }, onResizeStart: () => {
            setMailListResizeProcessing && setMailListResizeProcessing(!0);
        }, defaultWidth: defaultWidth },
        React.createElement(ErrorBoundary, { name: "ColumnMailBoxContainer" }, children)));
};
export default ColumnMailBoxContainer;
